__turbopack_context__.v({
  "receipt": "school-request-waitlist-module-scss-module__yUQlTW__receipt",
  "submit": "school-request-waitlist-module-scss-module__yUQlTW__submit",
});
